module.exports = __webpack_public_path__ + "img/line1.48724bae.svg";